/* global Modernizr */
export const init = () => {
	if (Modernizr.objectfit) return;

	const elements = [...document.querySelectorAll('.b-video__img')];

	const init = (element) => {
		const image = element.querySelector('img');
		const src = image.getAttribute('src');

		element.style.backgroundImage = `url('${src}')`;
	};


	elements.forEach(init);
};
